import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ServiceAppService } from './../../../../security/service-app.service';
import { IFiltros, ITotaisPrincipal } from '../interface-apuracao-vdm';

@Component({
  selector: 'app-apuracao-vdm-principal',
  templateUrl: './apuracao-vdm-principal.component.html',
  styleUrls: ['./apuracao-vdm-principal.component.scss']
})
export class ApuracaoVdmPrincipalComponent implements OnInit {
  cols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean;

  totaisPrincipal: ITotaisPrincipal = {
    totalBudgetFull: 0,
    totalBudgetMtd: 0,
    totalRealizado: 0,
    totalGapMesFull: 0,
    totalGapMesYtd: 0,
    totalDescontoMes: 0,
    totalComDescontoMes: 0,
  }

  @Input() filtros: IFiltros;
  @ViewChild('dt') dt: Table;
  constructor(private service: ServiceAppService) { }

  ngOnInit(): void {
    this.retornaDados();

    this.cols = [
      { field: 'codDealer', header: 'Dealer' },
      { field: 'nomeDealer', header: 'Nome' },
      { field: 'budgetFull', header: 'Budget Full' },
      { field: 'budgetMtd', header: 'Budget MTD' },
      { field: 'realizadoMes', header: 'Valor Bruto' },
      { field: 'descontoMes', header: 'Valor Desconto' },
      { field: 'comDescontoMes', header: 'Valor Líquido' },
      { field: 'gapMesFull', header: 'Gap Mês Full' },
      { field: 'gapMesYtd', header: 'Gap Mês YTD' },
    ];
  }

  public retornaDados() {
    this.loading = true;
    this.service.getDados(`/apuracao_vdm_mensal?dataAno=${this.filtros.dataAno}&selecaoVdm=${this.filtros.selecaoVdm}&considerarBalcao=${this.filtros.considerarBalcao}`).subscribe(res => {
      this.dados = res.dados;

      this.totaisPrincipal = {
        totalBudgetFull: res.totalBudgetFull,
        totalBudgetMtd: res.totalBudgetMtd,
        totalRealizado: res.totalRealizadoMes,
        totalGapMesFull: res.totalGapMesFull,
        totalGapMesYtd: res.totalGapMesYtd,
        totalDescontoMes: res.totalDescontoMes,
        totalComDescontoMes: res.totalComDescontoMes
      }

      this.loading = false;
    });
  }
}